import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

// material ui
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

const CartEmpty = props => {
  return (
    <Card elevation={1}>
      <CardContent>
        <Typography my={4} align='center'>
          Your cart is empty. Please{' '}
          <Link component={RouterLink} to='/cart'>
            add a product
          </Link>{' '}
          to continue.
        </Typography>
      </CardContent>
    </Card>
  )
}

export default CartEmpty
